module.exports = __webpack_public_path__ + "img/04-6.fdb024bc.png";